import { AllocationGroupType } from '@/components/AllocationSelectionPanel/AllocationSelectionPanel.types';
import { eventVariantStatusToBadgeVariant, getEventVariantRoute, getEventVariantStatusLabel } from '@/event/event';
import { externalEventVariantStatusToBadgeVariant, getExternalEventVariantRoute } from '@/external_event/externalEvent';
import { $t } from '@/plugins/fluent';
import {
    getProjectVariantRoute,
    getProjectVariantStatusLabel,
    projectVariantStatusToBadgeVariant,
} from '@/project/project';

export function getVariantRoute(type: AllocationGroupType, objectId: string, index: number) {
    switch (type) {
        case 'Event':
            return getEventVariantRoute(objectId, index);
        case 'Project':
            return getProjectVariantRoute(objectId, index);
        case 'ExternalEvent':
            return getExternalEventVariantRoute(objectId, index);
    }
}

export function getVariantStatusLabel(type: AllocationGroupType, status: string) {
    switch (type) {
        case 'Event':
            return getEventVariantStatusLabel(status);
        case 'Project':
            return getProjectVariantStatusLabel(status);
        case 'ExternalEvent':
            return $t('external-event-variant-status', { status });
    }
}

export function variantStatusToBadgeVariant(type: AllocationGroupType, status: string) {
    switch (type) {
        case 'Event':
            return eventVariantStatusToBadgeVariant(status);
        case 'Project':
            return projectVariantStatusToBadgeVariant(status);
        case 'ExternalEvent':
            return externalEventVariantStatusToBadgeVariant(status);
    }
}
